import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import views from './views';
import transitions from './transitions';

export default class BarbaApp {
	constructor() {
		this.scrollPos = [];

		if (history.scrollRestoration) {
			history.scrollRestoration = 'manual';
		}

		barba.hooks.before(({ current, next, trigger }) => {
			//
		});

		barba.hooks.beforeLeave(({ current, next, trigger }) => {
			//
		});

		barba.hooks.leave(({ current, next, trigger }) => {
			//
		});

		barba.hooks.afterLeave(({ current, next, trigger }) => {
			//
		});

		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			const parser = new DOMParser();
			const nextDoc = parser.parseFromString(next.html, 'text/html');

			const body = nextDoc.body;
			const bodyClasses = Array.from(body.classList);
			document.body.classList.remove(...document.body.classList);
			document.body.classList.add(...bodyClasses);

			const nextHeader = nextDoc.querySelector('header');
			const header = document.querySelector('header');
			header.innerHTML = nextHeader.innerHTML;

			const blessEvent = new Event('bless', {
				bubbles: true,
			});

			next.container.dispatchEvent(blessEvent);
		});

		const isScrollRestore = ({ current, next, trigger }) =>
			trigger === 'back' ||
			(current.namespace === 'single-project' && next.namespace === 'template-projects');

		barba.hooks.enter((data) => {
			if (!isScrollRestore(data)) {
				this.scrollPos.push({
					x: barba.history.current.scroll.x,
					y: barba.history.current.scroll.y,
				});
			}
		});

		barba.hooks.afterEnter((data) => {
			if (isScrollRestore(data)) {
				const pos = this.scrollPos.pop();
				if (pos) {
					window.scrollTo(pos.x, pos.y);
				}
			} else {
				window.scrollTo(0, 0);
			}
		});

		barba.hooks.after(({ current, next, trigger }) => {
			// evalScripts(next);
		});

		barba.use(barbaPrefetch, {
			limit: 5,
		});

		barba.init({
			debug: window.WPDATA.env == 'development' ? true : false,
			timeout: 5000,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					console.log('Preventing Barba navigation due to 404 on back/forward navigation');
					return true;
				}

				return false;
			},
			prevent: ({ el, event, href }) => {
				const url = new URL(href);

				if (!url) {
					return false;
				}

				// Prevent external links
				if (url.hostname !== window.location.hostname) {
					return true;
				}

				// Prevent if not a /-link
				if (!url.pathname.endsWith('/')) {
					return true;
				}

				return false;
			},
			views,
			transitions,
		});
	}
}
